module.exports = __webpack_public_path__ + "img/excursiones1.74b08972.jpg";